import { validate } from "../../helpers/validate.js";
import { attributesCodeBlockSchema } from "./attributes.js";
import { guideCodeBlockHtml } from "./component.js";
import { ScalarCodeBlockVue } from "./component.js";
import { parseCodeBlockMeta } from "./helpers.js";
import { nanoid } from "@scalar-org/entities/utility";
import { hydrate } from "./hydration.js";
const scalarCodeBlock = {
  name: "scalar-code",
  tagName: "scalar-code",
  tiptapName: "custom_code_block",
  attributeTransform: (_, attrs) => {
    return validate(attributesCodeBlockSchema, {
      ...attrs,
      lang: attrs.lang || "plaintext",
      // ---------------------------------------------------------------------------
      // Adding a unique ID to each code block allows us to use the ids when
      // the code blocks are inside a code group
      id: attrs.id || nanoid()
    });
  },
  render: async (props) => {
    const transformed = scalarCodeBlock.attributeTransform("", props);
    return transformed ? guideCodeBlockHtml(transformed) : "";
  },
  hydrate
};
export {
  ScalarCodeBlockVue,
  parseCodeBlockMeta,
  scalarCodeBlock
};
//# sourceMappingURL=index.js.map
